import { Injectable } from '@angular/core';
import { Profile } from '@app/profile/profile.model';
import { MenuViewModel } from '@app/shared/components/menu/menu.component';
import { FeedbackService } from '@app/feedback/services/feedback.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ProfileOverviewActionsService } from '@app/profile/components/profile-overview/profile-overview-actions/profile-overview-actions.service';

@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  public i18n = this.translateService.instant([
    'ProfileCtrl_ShareProfile',
    'Core_ReportAProblem',
    'Core_Settings',
  ]);

  constructor(
    private feedbackService: FeedbackService,
    private translateService: TranslateService,
    private profileOverviewActionsService: ProfileOverviewActionsService,
    private router: Router
  ) {}
  /**
   * Get the config for the meatball menu on the UserInfoComponent.
   *
   * @param owner - The user info component profile object.
   */
  public getNonOwnerUserInfoMenu(owner: Profile): MenuViewModel[] {
    return [
      {
        title: this.i18n.ProfileCtrl_ShareProfile,
        defaultAction: (_, popoverTrigger) => {
          this.profileOverviewActionsService.copyProfileUrl(owner, true);
        },
      },
      {
        title: this.i18n.Core_ReportAProblem,
        defaultAction: (_, popoverTrigger) => {
          this.feedbackService
            .showReportProblemModal(
              {
                itemType: this.feedbackService.feedbackItemType.Profile,
                itemId: owner.userProfileKey,
              },
              popoverTrigger.nativeElement
            )
            .subscribe();
        },
      },
    ];
  }

  public getOwnerUserInfoMenu(
    owner: Profile,
    isMobile: boolean
  ): MenuViewModel[] {
    return [
      {
        title: this.i18n.Core_Settings,
        defaultAction: (_, popoverTrigger) => {
          this.router.navigateByUrl(`/profile/${owner.vanityUrl}/settings`);
        },
        isHidden: () => !isMobile,
      },
      {
        title: this.i18n.ProfileCtrl_ShareProfile,
        defaultAction: (_, popoverTrigger) => {
          this.profileOverviewActionsService.copyProfileUrl(owner, true);
        },
      },
    ];
  }
}
